import {
  faCheck,
  faInfoCircle,
  faTimes,
  faBan,
} from "@fortawesome/free-solid-svg-icons";
import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  Fragment,
  useCallback,
} from "react";
import NumberFormat from "react-number-format";
import { formatExpenseDate } from "../../helpers/utils";
import moment from "moment";
import { useSelector } from "react-redux";
import { useParams, useHistory } from "react-router";
import { Toast } from "./../UI/toast/Toast";
import {
  Alert,
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import { checkUserToken } from "../../helpers/api/auth";
import {
  changeStatusPayment,
  fetchOneAliquotByProperty,
  fetchOneBillToPay,
} from "../../helpers/api/finance";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import VoidPaymentModal from "./VoidPaymentModal";
import { rateRuleSummary } from "./RateRuleNotice";
import withRedirect from "../../helpers/hoc/withRedirect";
import ButtonIcon from "../common/ButtonIcon";
import Loader from "../common/Loader";
import PageHeader from "../common/PageHeader";
import Logo from "../navbar/Logo";
import SupportLink from "../root/support/components/SupportLink";
import { useReactToPrint } from "react-to-print";
import { CurrencyContext } from "../../context/Context";
import { findConfigAsProperty } from "../../helpers/api/condominium";
import ItemImageTitleSubProperty from "../common/ItemImageTitleSubProperty";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import useModuleBase from "../../helpers/hooks/useModuleBase";

const PropertyPaymentDetail = ({ setRedirect, setRedirectUrl }) => {
  const moduleBase = useModuleBase();
  const { propertyPayment, id } = useParams();
  const history = useHistory();
  const reportRef = useRef();
  const { role, token } = useSelector((state) => state.auth.user);
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { condominium, address, phone } = useSelector(
    (state) => state.condominium
  );
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [collapseOne, collapseOneOpen] = useState(false);
  const [loadingSubmit, setloadingSubmit] = useState(false);
  const [aliquots, setAliquots] = useState(null);
  const { currency: curr, baseCurrency } = useContext(CurrencyContext);
  const [datas, setDatas] = useState(null);
  const [isVoidOpen, setIsVoidOpen] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const activeRate = datas?.exchange_rate || curr;

  const [dataConfig, setDataConfig] = useState({
    data: null,
    loading: true,
  });
  const [users, setUser] = useState(null);


  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const { data } = await fetchOneBillToPay(propertyPayment);
        if (isMounted) {
          setDatas(data);
          if (role === "manager") {
            setProperty(data?.billPropertyPayment?.[0]?.property?.property?.user || {});
          }
          setLoading(false);
        }
      } catch (error) {
        if (isMounted) {
          setLoading(false);
          handleErrorMessage(error);
        }
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [reloadKey]);

  /*   const [amount, setAmount] = useState(0);
  useEffect(() => {
    const monto = reference
      .reduce((a, c) => {
        return a + c.amount;
      }, 0)
      .toFixed(2);
    setAmount(monto);
  }, [reference]); */

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
  });
  useEffect(() => {
    let isMounted = true;
    if (role === "property") {
      const getMyProfile = async () => {
        try {
          const data = await checkUserToken(token);
          if (isMounted) setProperty(data);
        } catch (error) {
          if (isMounted) Toast.fire({
            title:
              "Ha ocurrido un error al obtener los datos, por favor intente nuevamente más tarde.",
            type: "error",
          });
        }
      };
      getMyProfile();
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!selectedCondominium) return;
    if (dataConfig.data) return;
    let isMounted = true;
    const loadConfig = async () => {
      try {
        const { data } = await findConfigAsProperty(selectedCondominium);
        if (isMounted) {
          setDataConfig({
            data,
            loading: false,
          });
        }
      } catch (error) {
        if (isMounted) {
          setDataConfig({
            data: null,
            loading: false,
          });
          console.error("Error fetching config:", error.message);
          handleErrorMessage(error);
        }
      }
    };

    const findOne = async () => {
      try {
        const response = await checkUserToken(token);
        if (isMounted) setUser(response);

        const fetchData = async () => {
          try {
            const { data } = await fetchOneAliquotByProperty(
              response.propertyId
            );
            if (isMounted) setAliquots(data);
          } catch (error) {
            console.log(error);
          }
        };
        fetchData();
      } catch (error) {
        if (isMounted) handleErrorMessage(error);
      }
    };

    findOne();
    loadConfig();

    return () => {
      isMounted = false;
    };
  }, []);

  const formatDateSafe = (date) => {
    if (!date) return "";

    const raw = String(date).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
      const [year, month, day] = raw.split("-");
      return `${Number(day)}/${Number(month)}/${year}`;
    }

    const parsed = moment(raw);
    return parsed.isValid() ? parsed.format("D/M/YYYY") : "";
  };

  const cancel = async () => {
    setloadingSubmit(true);
    try {
      const { code } = await changeStatusPayment(propertyPayment, {
        status: "canceled",
      });
      if (code === SUCCESS_RESPONSE.SUCCESFUL) {
        setRedirectUrl(`/dashboard/my/finance/pays`);
        setRedirect(true);
        Toast.fire({
          type: "success",
          title: `Pago cancelado exitosamente.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    } finally {
      setloadingSubmit(false);
    }
  };

  const refuse = async (property_payment_id) => {
    setloadingSubmit(true);
    try {
      const { code } = await changeStatusPayment(property_payment_id, {
        status: "refused",
      });
      if (code === SUCCESS_RESPONSE.SUCCESFUL) {
        setRedirectUrl(`/dashboard/${moduleBase}/${id}/payments`);
        setRedirect(true);
        Toast.fire({
          type: "success",
          title: `Pago cancelado exitosamente.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    } finally {
      setloadingSubmit(false);
    }
  };

  const propertyData = datas?.billPropertyPayment;

  const [report, setReport] = useState([]);
  const [reportE, setReportE] = useState([]);
  const [reportI, setReportI] = useState([]);
  const [funds, setFunds] = useState([]);
  const [reportIncomes, setReportIncomes] = useState([]);
  const [amount, setAmount] = useState(0);
  const [amountE, setAmountE] = useState(0);
  const [amountI, setAmountI] = useState(0);
  const [amountF, setAmountF] = useState(0);
  const [amountIncomes, setAmountIncomes] = useState(0);

  const fetchApireports = useCallback(async () => {
    if (!propertyData) return;
    try {
      // type.id 5 = "Deuda Inicial" (saldo inicial importado): se muestra junto
      // a los gastos ordinarios, no como extraordinario (ver TypeFinancesSeeder).
      const financeType1Reports = propertyData?.filter(
        (report) =>
          report?.property?.finance !== null &&
          (report?.property?.finance?.type?.id === 1 ||
            report?.property?.finance?.type?.id === 5)
      );
      const financeType2Reports = propertyData?.filter(
        (report) =>
          (report?.property?.finance !== null &&
            report?.property?.finance?.type?.id === 2) ||
          (!report?.property?.income_id &&
            !report?.property?.reserve_fund &&
            !report?.property?.reserve_fund_payment_id &&
            Number(report?.property?.amount) > 0 &&
            report?.property?.finance?.type?.id !== 1 &&
            report?.property?.finance?.type?.id !== 3 &&
            report?.property?.finance?.type?.id !== 5)
      );

      const financeType3Reports = propertyData?.filter(
        (report) =>
          report?.finance !== null && report?.property?.finance?.type?.id === 3
      );
      const reserveReports = propertyData?.filter(
        (report) => report?.property?.reserve_fund !== null
      );
      const incomeReports = propertyData?.filter(
        (report) =>
          Boolean(report?.property?.income_id) ||
          Boolean(report?.property?.income) ||
          Number(report?.property?.amount) < 0
      );

      setReport(financeType1Reports ?? []);
      setReportE(financeType2Reports ?? []);
      setReportI(financeType3Reports ?? []);
      setFunds(reserveReports ?? []);
      setReportIncomes(incomeReports ?? []);
    } catch (error) {
      console.log(error);
      setReport([]);
    }
  }, [propertyData]);

  useEffect(() => {
    fetchApireports();
  }, [fetchApireports, propertyData]);

  // HO-TASK-247: los subtotales se guardan con todos sus decimales; redondear
  // cada uno a 2 y después sumarlos hacía que el total no coincidiera con la
  // suma real de las filas. Mostrar con 2 decimales es cosa de NumberFormat.
  useEffect(() => {
    // Gasto ordinario
    const monto =
      report?.reduce((a, c) => {
        return a + Number(c?.property?.amount || 0);
      }, 0) || 0;
    setAmount(monto);

    // Gasto extraordinario

    const montoE =
      reportE?.reduce((a, c) => {
        return a + Number(c?.property?.amount || 0);
      }, 0) || 0;
    setAmountE(montoE);

    // Gasto individual

    const montoI =
      reportI?.reduce((a, c) => {
        return a + Number(c?.property?.amount || 0);
      }, 0) || 0;
    setAmountI(montoI);

    // Fondo de reserva

    const montoF =
      funds?.reduce((a, c) => {
        return a + Number(c?.property?.amount || 0);
      }, 0) || 0;
    setAmountF(montoF);

    // Ingresos aplicados
    const montoInc =
      reportIncomes?.reduce((a, c) => {
        return a + Math.abs(Number(c?.property?.amount || 0));
      }, 0) || 0;
    setAmountIncomes(montoInc);
  }, [report, reportE, reportI, funds, reportIncomes]);

  const approve = async (property_payment_id) => {
    setloadingSubmit(true);
    try {
      const { code } = await changeStatusPayment(property_payment_id, {
        status: "approved",
      });
      if (code === SUCCESS_RESPONSE.SUCCESFUL) {
        setRedirectUrl(`/dashboard/${moduleBase}/${id}/payments`);
        setRedirect(true);
        Toast.fire({
          type: "success",
          title: `Pago aprobado exitosamente.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    } finally {
      setloadingSubmit(false);
    }
  };

  const fechaFormateada = formatDateSafe(
    propertyData && propertyData[0]?.property?.period?.end_at
  );

  const fechaFormateadaE = formatDateSafe(datas && datas?.created_at);

  const totalAmount = Number(datas?.total_amount || 0);
  const accumulatedAmount = Number(datas?.paid_amount || 0);
  const accumulatedAmountConverted = Number(datas?.paid_amount_converted || 0);
  const currentPaymentAmount = Number(datas?.amount || 0);
  const pendingAmount = Number(datas?.pending_amount || 0);
  const isFullyPaid = Boolean(datas?.is_fully_paid);

  // Badge junto a "Monto abonado": si ESTE pago todavía no está aprobado, su
  // monto no está incluido arriba — se indica aparte con su propio valor.
  const depositBadge =
    datas?.status === "pending"
      ? {
          label: (
            <>
              +{" "}
              <NumberFormat
                displayType="text"
                prefix={`${baseCurrency.symbol} `}
                decimalScale={2}
                fixedDecimalScale
                thousandSeparator={true}
                value={currentPaymentAmount}
              />{" "}
              por aprobar
            </>
          ),
          className: "badge-soft-warning",
        }
      : datas?.status === "refused"
        ? { label: "Rechazado", className: "badge-soft-danger" }
        : datas?.status === "canceled"
          ? { label: "Cancelado", className: "badge-soft-secondary" }
          : datas?.status === "voided"
            ? { label: "Anulado", className: "badge-soft-danger" }
            : null;

  const balanceBadge = isFullyPaid
    ? { label: "Pagado", className: "badge-soft-success" }
    : { label: "Pendiente", className: "badge-soft-warning" };

  const lineRateOf = (line) => Number(line?.exchange_rate?.value || 0);
  const lineIsoOf = (line) =>
    line?.exchange_rate?.currency?.iso || activeRate?.currency?.iso;

  const lineDateAndRateCells = (line) => (
    <>
      <td className="align-middle text-nowrap">
        {formatExpenseDate(line?.expense_date)}
      </td>
      <td className="align-middle text-nowrap">
        {lineRateOf(line) > 0 && lineIsoOf(line) && (
          <NumberFormat
            displayType="text"
            prefix={`${lineIsoOf(line)} `}
            allowedDecimalSeparators={true}
            decimalScale={2}
            fixedDecimalScale
            thousandSeparator={true}
            value={lineRateOf(line)}
          />
        )}
      </td>
    </>
  );

  const lineTotalCell = (line) => {
    const total = line?.concept_amount ?? line?.finance?.value;
    const totalBs =
      line?.concept_amount_converted ??
      (total !== null && total !== undefined && lineRateOf(line) > 0
        ? total * lineRateOf(line)
        : null);

    return (
      <td className="align-middle text-right">
        {total === null || total === undefined ? (
          "-"
        ) : (
          <>
            <span className="d-block font-weight-semi-bold">
              <NumberFormat
                className="text-nowrap"
                displayType="text"
                prefix={`${baseCurrency.symbol} `}
                allowedDecimalSeparators={true}
                decimalScale={2}
                fixedDecimalScale
                thousandSeparator={true}
                value={total}
              />
            </span>
            {totalBs !== null && lineIsoOf(line) && (
              <span className="d-block text-700 fs--2 text-nowrap">
                <NumberFormat
                  className="text-right text-nowrap"
                  displayType="text"
                  prefix={`${lineIsoOf(line)} `}
                  allowedDecimalSeparators={true}
                  decimalScale={2}
                  fixedDecimalScale
                  thousandSeparator={true}
                  value={totalBs}
                />
              </span>
            )}
          </>
        )}
      </td>
    );
  };

  return (
    <Fragment>
      <VoidPaymentModal
        isOpen={isVoidOpen}
        toggle={() => setIsVoidOpen(false)}
        kind="bill"
        paymentId={datas?.id}
        onVoided={() => setReloadKey((key) => key + 1)}
      />
      <PageHeader
        title="Detalle de pago"
        titleTag="h2"
        description={
          role === "property"
            ? "Visualiza tu pago realizado."
            : "Visualiza el pago del propietario"
        }
        className="mb-3"
        col={{ lg: 9 }}
      >
        {role === "manager" && <SupportLink />}
      </PageHeader>

      {!loading && property && !loadingSubmit && (
        <Card className="mb-3">
          <CardBody>
            <Row className="justify-content-end align-items-center d-flex">
              <Col
                xs="auto"
                lg={"auto"}
                md={12}
                className="justify-self-end d-flex justify-content-end align-items-center"
              >
                <ButtonIcon
                  onClick={() => history.goBack()}
                  color="falcon-default"
                  size="sm"
                  icon="chevron-left"
                  className="mr-2 mb-2 mb-sm-0"
                >
                  Volver
                </ButtonIcon>
                <ButtonIcon
                  color="falcon-default"
                  size="sm"
                  icon="arrow-down"
                  disabled
                  className="mr-2 mb-2 mb-sm-0"
                >
                  Descargar (.pdf)
                </ButtonIcon>
                <ButtonIcon
                  onClick={() => handlePrint()}
                  color="falcon-default"
                  size="sm"
                  icon="print"
                  disabled={!datas}
                  className="mr-2 mb-2 mb-sm-0"
                >
                  Imprimir
                </ButtonIcon>
                {role === "property" && datas?.status === "pending" && (
                  <ButtonIcon
                    color="falcon-danger"
                    size="sm"
                    icon={faTimes}
                    className="mb-2 mb-sm-0"
                    onClick={() => collapseOneOpen(!collapseOne)}
                  >
                    Cancelar pago
                  </ButtonIcon>
                )}
                {role === "manager" ? (
                  datas.status === "pending" ? (
                    <>
                      <ButtonIcon
                        color="falcon-success"
                        size="sm"
                        icon={faCheck}
                        className="mb-2 mr-2  mb-sm-0"
                        onClick={() => approve(datas?.id)}
                      >
                        Aprobar pago
                      </ButtonIcon>
                      <ButtonIcon
                        color="falcon-danger"
                        size="sm"
                        icon={faTimes}
                        className="mb-2 mb-sm-0"
                        onClick={() => refuse(datas?.id)}
                      >
                        Rechazar pago
                      </ButtonIcon>
                    </>
                  ) : datas.status === "approved" ? (
                    <ButtonIcon
                      color="falcon-danger"
                      size="sm"
                      icon={faBan}
                      className="mb-2 mb-sm-0"
                      onClick={() => setIsVoidOpen(true)}
                    >
                      Anular pago
                    </ButtonIcon>
                  ) : (
                    <></>
                  )
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}

      {datas?.status === "voided" && (
        <Alert color="danger" className="shadow-sm fs--1">
          <strong className="d-block">Pago anulado</strong>
          {datas?.void_reason && (
            <span className="d-block">Motivo: {datas.void_reason}</span>
          )}
          <span className="d-block fs--2">
            {`Anulado el ${formatDateSafe(datas?.voided_at)}${datas?.voided_by_name ? ` por ${datas.voided_by_name}` : ""}`}
          </span>
        </Alert>
      )}

      <Card
        innerRef={(e) => {
          reportRef.current = e;
        }}
      >
        {!loading && property && !loadingSubmit ? (
          <CardBody>
            <ItemImageTitleSubProperty
              image={dataConfig?.data?.logo}
              title1={"Planilla de liquidación de gastos"}
              titleCondominium={`Condominio: ${condominium}`}
              titleProperty={"Datos del inmueble"}
              titleInvoice={"Datos adicionales"}
              condominium={[
                {
                  label: "Documento de identificación",
                  value: phone || "No disponible",
                },
                /*     {
                        label: "Teléfono",
                        value: userData.phone || "No disponible",
                      }, */
                { label: "Dirección", value: address },
              ]}
              property={[
                {
                  label: "Propietario",
                  value: `${users?.data?.firstname} ${users?.data?.lastname}`,
                },
                {
                  label: "Teléfono",
                  value: users?.data?.phone || "No disponible",
                },
                {
                  label: "Inmueble",
                  value: users?.property || "No disponible",
                },
                {
                  label: "Alícuota",
                  value: (aliquots?.value / 100)?.toFixed(4),
                },
              ]}
              invoice={[
                ...(datas?.control_number
                  ? [{ label: "N° de control", value: datas.control_number }]
                  : []),
                {
                  label: "Fecha de emisión",
                  value: datas ? fechaFormateadaE : "No disponible",
                },
                {
                  label: "Fecha de vencimiento",
                  value:
                    propertyData && propertyData[0]?.property?.period?.end_at
                      ? fechaFormateada
                      : "No disponible",
                },
                {
                  label: "Período",
                  value:
                    propertyData && propertyData[0]?.property?.period?.name,
                },
                {
                  label: "Estatus",
                  value:
                    datas?.status === "pending"
                      ? "Pendiente"
                      : datas?.status === "refused"
                        ? "Pago rechazado"
                        : datas?.status === "canceled"
                          ? "Cancelado"
                          : datas?.status === "voided"
                            ? "Anulado"
                            : "Aprobado",
                },
                {
                  label: "Fecha de pago",
                  value: datas?.payment_date
                    ? formatDateSafe(datas?.payment_date)
                    : datas?.created_at
                      ? formatDateSafe(datas?.created_at)
                      : "",
                },
                {
                  label: "Tasa de cambio",
                  value:
                    activeRate?.currency?.iso && Number(activeRate?.value || 0) > 0 ? (
                      <>
                        <NumberFormat
                          displayType="text"
                          prefix={`${baseCurrency.symbol} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={1}
                        />
                        <NumberFormat
                          displayType="text"
                          prefix={` | ${activeRate.currency.iso} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={Number(activeRate.value)}
                        />
                        {(datas?.exchange_rate?.date || datas?.payment_date) &&
                          ` (${formatDateSafe(datas?.exchange_rate?.date || datas?.payment_date)})`}
                      </>
                    ) : (
                      "No disponible"
                    ),
                },
                // Con qué tasa se reportó y por qué. Los pagos anteriores a
                // la tasa congelada no la tienen.
                ...(rateRuleSummary(datas?.rate_rule)
                  ? [{ label: "Tasa aplicada", value: rateRuleSummary(datas.rate_rule) }]
                  : []),
              ]}
              loading={dataConfig.loading}
            />

            {datas && (
              // mb-3 como el resto de los bloques (HO-TASK-247): con
              // mt-1 mb-2 quedaba pegado a las tarjetas de datos.
              <div className="border border-200 rounded mb-3">
                <Row className="g-0 text-center text-sm-left">
                  <Col xs={12} sm={3} className="pl-4 pr-3 py-1">
                    <div className="fs--1 text-600 font-weight-semi-bold mb-0">
                      Monto total
                    </div>
                    <div className="fs-0 font-weight-bold text-900">
                      <NumberFormat
                        displayType="text"
                        prefix={`${baseCurrency.symbol} `}
                        allowedDecimalSeparators={true}
                        decimalScale={2}
                        fixedDecimalScale
                        thousandSeparator={true}
                        value={totalAmount}
                      />
                    </div>
                    {activeRate?.currency?.iso && (
                      <div className="fs--1 text-600">
                        <NumberFormat
                          displayType="text"
                          prefix={activeRate.currency.iso + " "}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={totalAmount * (activeRate?.value || 0)}
                        />
                      </div>
                    )}
                  </Col>
                  <Col
                    xs={12}
                    sm={3}
                    className="pl-3 pr-4 py-1 border-left border-200"
                  >
                    <div className="d-flex justify-content-between align-items-center mb-0">
                      <span className="fs--1 text-600 font-weight-semi-bold">
                        Monto acumulado
                      </span>
                    </div>
                    <div className="fs-0 font-weight-bold text-900">
                      <NumberFormat
                        displayType="text"
                        prefix={`${baseCurrency.symbol} `}
                        allowedDecimalSeparators={true}
                        decimalScale={2}
                        fixedDecimalScale
                        thousandSeparator={true}
                        value={accumulatedAmount}
                      />
                    </div>
                    {activeRate?.currency?.iso && (
                      <div className="fs--1 text-600">
                        <NumberFormat
                          displayType="text"
                          prefix={activeRate.currency.iso + " "}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={accumulatedAmountConverted}
                        />
                      </div>
                    )}
                  </Col>
                  <Col
                    xs={12}
                    sm={3}
                    className="pl-3 pr-4 py-1 border-left border-200"
                  >
                    <div className="d-flex justify-content-between align-items-center mb-0">
                      <span className="fs--1 text-600 font-weight-semi-bold">
                        Monto abonado
                      </span>
                      {depositBadge && (
                        <Badge className={classNames("rounded-capsule", depositBadge.className)}>
                          {depositBadge.label}
                        </Badge>
                      )}
                    </div>
                    <div className="fs-0 font-weight-bold text-900">
                      <NumberFormat
                        displayType="text"
                        prefix={`${baseCurrency.symbol} `}
                        allowedDecimalSeparators={true}
                        decimalScale={2}
                        fixedDecimalScale
                        thousandSeparator={true}
                        value={currentPaymentAmount}
                      />
                    </div>
                    {activeRate?.currency?.iso && (
                      <div className="fs--1 text-600">
                        <NumberFormat
                          displayType="text"
                          prefix={activeRate.currency.iso + " "}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={currentPaymentAmount * (activeRate?.value || 0)}
                        />
                      </div>
                    )}
                  </Col>
                  <Col
                    xs={12}
                    sm={3}
                    className="pl-3 pr-4 py-1 border-left border-200"
                  >
                    <div className="d-flex justify-content-between align-items-center mb-0">
                      <span className="fs--1 text-600 font-weight-semi-bold">
                        Saldo pendiente
                      </span>
                      <Badge className={classNames("rounded-capsule", balanceBadge.className)}>
                        {balanceBadge.label}
                      </Badge>
                    </div>
                    <div
                      className={classNames(
                        "fs-0 font-weight-bold",
                        isFullyPaid ? "text-900" : "text-warning"
                      )}
                    >
                      <NumberFormat
                        displayType="text"
                        prefix={`${baseCurrency.symbol} `}
                        allowedDecimalSeparators={true}
                        decimalScale={2}
                        fixedDecimalScale
                        thousandSeparator={true}
                        value={pendingAmount}
                      />
                    </div>
                    {activeRate?.currency?.iso && (
                      <div className="fs--1 text-600">
                        <NumberFormat
                          displayType="text"
                          prefix={activeRate.currency.iso + " "}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={pendingAmount * (activeRate?.value || 0)}
                        />
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            )}

            {datas?.note != null && (
              <Row className="justify-content-between align-items-center fs--1 ">
                <Col>
                  <div className="text-start text-muted mt-3 pt-1 mb-0">
                    <div className="mb-0 d-flex align-items-center">
                      {" "}
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        className="me-2 mr-2"
                        size="sm"
                      />
                      <span className="text-start text-muted mr-2">Nota: </span>
                      <pre
                        style={{
                          fontFamily: "Open Sans",
                          fontSize: ".83333rem",
                          color: "#5e6e82",
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                          margin: 0,
                        }}
                      >
                        {datas?.note}
                      </pre>
                    </div>
                  </div>
                </Col>
              </Row>
            )}

            {report && report?.length > 0 && (
              <div className="table-responsive mt-4 fs--1">
                <Table striped className="border-bottom">
                  <thead>
                    <tr>
                      <th className="border-0" style={{ width: "22%" }}>Gastos ordinarios</th>
                      <th className="border-0" style={{ width: "14%" }}>Proveedor</th>
                      <th className="border-0" style={{ width: "16%" }}>Descripción</th>
                      <th className="border-0" style={{ width: "10%", whiteSpace: "nowrap" }}>Fecha del gasto</th>
                      <th className="border-0" style={{ width: "10%", whiteSpace: "nowrap" }}>Tasa</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Monto</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Cuota</th>
                    </tr>
                  </thead>
                  <tbody>
                    {report &&
                      report.map((pay, index) => (
                        <tr key={index}>
                          <td className="align-middle">
                            <h6 className="mb-0">
                              {pay?.property?.name
                                ? pay?.property?.name
                                : pay?.property?.finance?.name}
                            </h6>
                          </td>
                          <td className="align-middle">
                            <p className="mb-0">
                              {pay?.property?.finance?.provider_name != null
                                ? pay?.property?.finance?.provider_name
                                : pay?.property?.finance?.provider?.name}
                            </p>
                          </td>
                          <td className="align-middle">
                            <p className="mb-0">
                              {pay?.property?.description
                                ? pay?.property?.description
                                : pay?.property?.finance?.description}
                            </p>
                          </td>
                          {lineDateAndRateCells(pay?.property)}
                          {lineTotalCell(pay?.property)}
                          <td className="align-middle text-right">
                            <span className="d-block font-weight-semi-bold">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                prefix={`${baseCurrency.symbol} `}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={pay?.property?.amount}
                              />
                            </span>
                            <span className="d-block text-700 fs--2 text-nowrap">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                prefix={activeRate?.currency?.iso + " "}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={
                                  pay?.property?.amount * (activeRate?.value || 0)
                                }
                              />
                            </span>
                          </td>
                        </tr>
                      ))}

                    <tr className="border-top">
                      <th className="text-900" colSpan={6}>
                        Total de gastos ordinarios
                      </th>
                      <td className="font-weight-semi-bold text-right">
                        <span className="d-block">
                          <NumberFormat
                            className="text-right text-nowrap"
                            displayType="text"
                            allowedDecimalSeparators={true}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale
                            prefix={`${baseCurrency.symbol} `}
                            value={amount}
                          />
                        </span>
                        <span className="d-block text-700 fs--2 text-nowrap">
                          <NumberFormat
                            className="text-right text-nowrap"
                            displayType="text"
                            prefix={activeRate?.currency?.iso + " "}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={amount * (activeRate?.value || 0)}
                          />
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}

            {reportE && reportE?.length > 0 && (
              <div className="table-responsive mt-4 fs--1">
                <Table striped className="border-bottom">
                  <thead>
                    <tr>
                      <th className="border-0" style={{ width: "22%" }}>Gastos extraordinarios</th>
                      <th className="border-0" style={{ width: "14%" }}>Proveedor</th>
                      <th className="border-0" style={{ width: "16%" }}>Descripción</th>
                      <th className="border-0" style={{ width: "10%", whiteSpace: "nowrap" }}>Fecha del gasto</th>
                      <th className="border-0" style={{ width: "10%", whiteSpace: "nowrap" }}>Tasa</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Monto</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Cuota</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportE &&
                      reportE.map((pay, index) => (
                        <tr key={index}>
                          <td className="align-middle">
                            <h6 className="mb-0">
                              {pay?.property?.finance != null
                                ? pay?.property?.finance?.name
                                : pay?.property?.reserve_fund.name}
                            </h6>
                          </td>
                          <td className="align-middle">
                            <p className="mb-0">
                              {pay?.property?.finance?.provider_name != null
                                ? pay?.property?.finance?.provider_name
                                : pay?.property?.finance?.provider?.name}
                            </p>
                          </td>
                          <td className="align-middle">
                            <p className="mb-0">
                              {pay?.property?.finance != null
                                ? pay?.property?.finance?.description
                                : pay?.property?.reserve_fund?.description}
                            </p>
                          </td>
                          {lineDateAndRateCells(pay?.property)}
                          {lineTotalCell(pay?.property)}
                          <td className="align-middle text-right">
                            <span className="d-block font-weight-semi-bold">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                prefix={`${baseCurrency.symbol} `}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={pay?.property?.amount}
                              />
                            </span>
                            <span className="d-block text-700 fs--2 text-nowrap">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                prefix={activeRate?.currency?.iso + " "}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={
                                  pay?.property?.amount * (activeRate?.value || 0)
                                }
                              />
                            </span>
                          </td>
                        </tr>
                      ))}

                    <tr className="border-top">
                      <th className="text-900" colSpan={6}>
                        Total de gastos extraordinarios
                      </th>
                      <td className="font-weight-semi-bold text-right">
                        <span className="d-block">
                          <NumberFormat
                            className="text-right text-nowrap"
                            displayType="text"
                            allowedDecimalSeparators={true}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale
                            prefix={`${baseCurrency.symbol} `}
                            value={amountE}
                          />
                        </span>
                        <span className="d-block text-700 fs--2 text-nowrap">
                          <NumberFormat
                            className="text-right text-nowrap"
                            displayType="text"
                            prefix={activeRate?.currency?.iso + " "}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={amountE * (activeRate?.value || 0)}
                          />
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}
            {reportI && reportI?.length > 0 && (
              <div className="table-responsive mt-4 fs--1">
                <Table striped className="border-bottom">
                  <thead>
                    <tr>
                      <th className="border-0" style={{ width: "26%" }}>Gastos particulares</th>
                      <th className="border-0" style={{ width: "22%" }}>Descripción</th>
                      <th className="border-0" style={{ width: "12%", whiteSpace: "nowrap" }}>Fecha del gasto</th>
                      <th className="border-0" style={{ width: "12%", whiteSpace: "nowrap" }}>Tasa</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Monto</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Cuota</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportI &&
                      reportI.map((pay, index) => (
                        <tr key={index}>
                          <td className="align-middle">
                            <h6 className="mb-0">
                              {pay?.property?.finance != null
                                ? pay?.property?.finance?.name
                                : pay?.property?.reserve_fund.name}
                            </h6>
                          </td>
                          <td className="align-middle">
                            <p className="mb-0">
                              {pay?.property?.finance != null
                                ? pay?.property?.finance?.description
                                : pay?.property?.reserve_fund?.description}
                            </p>
                          </td>
                          {lineDateAndRateCells(pay?.property)}
                          {lineTotalCell(pay?.property)}
                          <td className="align-middle text-right">
                            <span className="d-block font-weight-semi-bold">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                prefix={`${baseCurrency.symbol} `}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={pay?.property?.amount}
                              />
                            </span>
                            <span className="d-block text-700 fs--2 text-nowrap">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                prefix={activeRate?.currency?.iso + " "}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={
                                  pay?.property?.amount * (activeRate?.value || 0)
                                }
                              />
                            </span>
                          </td>
                        </tr>
                      ))}

                    <tr className="border-top">
                      <th className="text-900" colSpan={5}>
                        Total de gastos particulares
                      </th>
                      <td className="font-weight-semi-bold text-right">
                        <span className="d-block">
                          <NumberFormat
                            className="text-right text-nowrap"
                            displayType="text"
                            prefix={`${baseCurrency.symbol} `}
                            value={amountI}
                          />
                        </span>
                        <span className="d-block text-700 fs--2 text-nowrap">
                          <NumberFormat
                            className="text-right text-nowrap"
                            displayType="text"
                            prefix={(activeRate?.currency?.iso || "Bs") + " "}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={amountI * (activeRate?.value || 0)}
                          />
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}

            {funds && funds?.length > 0 && (
              <div className="table-responsive mt-4 fs--1">
                <Table striped className="border-bottom">
                  <thead>
                    <tr>
                      <th className="border-0" style={{ width: "26%" }}>Fondos de reserva</th>
                      <th className="border-0" style={{ width: "22%" }}>Descripción</th>
                      <th className="border-0" style={{ width: "12%", whiteSpace: "nowrap" }}>Fecha del gasto</th>
                      <th className="border-0" style={{ width: "12%", whiteSpace: "nowrap" }}>Tasa</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Monto</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Cuota</th>
                    </tr>
                  </thead>
                  <tbody>
                    {funds &&
                      funds.map((pay, index) => (
                        <tr key={index}>
                          <td className="align-middle" style={{ width: "40%" }}>
                            <h6 className="mb-0">
                              {pay?.property?.finance != null
                                ? pay?.property?.finance?.name
                                : pay?.property?.reserve_fund.name}
                            </h6>
                          </td>

                          <td className="align-middle" style={{ width: "40%" }}>
                            <p className="mb-0">
                              {pay?.property?.finance != null
                                ? pay?.property?.finance?.description
                                : pay?.property?.reserve_fund?.description}
                            </p>
                          </td>
                          {lineDateAndRateCells(pay?.property)}
                          {lineTotalCell(pay?.property)}
                          <td className="align-middle text-right">
                            <span className="d-block font-weight-semi-bold">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                prefix={`${baseCurrency.symbol} `}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={pay?.property?.amount}
                              />
                            </span>
                            <span className="d-block text-700 fs--2 text-nowrap">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                prefix={(activeRate?.currency?.iso || "Bs") + " "}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={
                                  pay?.property?.amount * (activeRate?.value || 0)
                                }
                              />
                            </span>
                          </td>
                        </tr>
                      ))}

                    <tr className="border-top">
                      <th className="text-900" colSpan={5}>
                        Total de fondos de reserva
                      </th>
                      <td className="font-weight-semi-bold text-right">
                        <span className="d-block">
                          <NumberFormat
                            className="text-right text-nowrap"
                            displayType="text"
                            allowedDecimalSeparators={true}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale
                            prefix={`${baseCurrency.symbol} `}
                            value={amountF}
                          />
                        </span>
                        <span className="d-block text-700 fs--2 text-nowrap">
                          <NumberFormat
                            className="text-right text-nowrap"
                            displayType="text"
                            prefix={(activeRate?.currency?.iso || "Bs") + " "}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={amountF * (activeRate?.value || 0)}
                          />
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}

            {reportIncomes && reportIncomes.length > 0 && (
              <div className="table-responsive mt-4 fs--1">
                <Table striped className="border-bottom">
                  <thead>
                    <tr>
                      <th className="border-0" style={{ width: "26%" }}>Ingresos aplicados</th>
                      <th className="border-0" style={{ width: "22%" }}>Descripción</th>
                      <th className="border-0" style={{ width: "12%", whiteSpace: "nowrap" }}>Fecha del ingreso</th>
                      <th className="border-0" style={{ width: "12%", whiteSpace: "nowrap" }}>Tasa</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Monto</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Descuento</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportIncomes.map((pay, index) => (
                      <tr key={index}>
                        <td className="align-middle">
                          <h6 className="mb-0">
                            {pay?.property?.name || pay?.property?.income?.name || "Ingreso a planilla"}
                          </h6>
                        </td>
                        <td className="align-middle">
                          <p className="mb-0">
                            {pay?.property?.description || pay?.property?.income?.description}
                          </p>
                        </td>
                        {lineDateAndRateCells(pay?.property)}
                        {lineTotalCell(pay?.property)}
                        <td className="align-middle text-right">
                          <span className="d-block font-weight-semi-bold text-success">
                            <NumberFormat
                              className="text-nowrap"
                              displayType="text"
                              prefix={`- ${baseCurrency.symbol} `}
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                              value={Math.abs(pay?.property?.amount || 0)}
                            />
                          </span>
                          <span className="d-block text-700 fs--2 text-nowrap text-success">
                            <NumberFormat
                              className="text-right text-nowrap"
                              displayType="text"
                              prefix={"- " + (activeRate?.currency?.iso || "Bs") + " "}
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                              value={Math.abs(pay?.property?.amount || 0) * (activeRate?.value || 0)}
                            />
                          </span>
                        </td>
                      </tr>
                    ))}

                    <tr className="border-top">
                      <th className="text-900" colSpan={5}>
                        Total ingresos descontados
                      </th>
                      <td className="font-weight-semi-bold text-right text-success">
                        <span className="d-block">
                          <NumberFormat
                            className="text-right text-nowrap"
                            displayType="text"
                            allowedDecimalSeparators={true}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale
                            prefix={`- ${baseCurrency.symbol} `}
                            value={amountIncomes}
                          />
                        </span>
                        <span className="d-block text-700 fs--2 text-nowrap text-success">
                          <NumberFormat
                            className="text-right text-nowrap"
                            displayType="text"
                            prefix={"- " + (activeRate?.currency?.iso || "Bs") + " "}
                            allowedDecimalSeparators={true}
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator={true}
                            value={amountIncomes * (activeRate?.value || 0)}
                          />
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}

            <Row noGutters className="ml-3 justify-content-end">
              {datas?.voucher && datas?.voucher !== "false" && (
                <Col>
                  <Table
                    striped
                    size="sm"
                    borderless
                    className="fs--1 text-left"
                  >
                    <thead>
                      <th className="border-0">Comprobante de pago</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div className="App mt-3">
                            <img
                              src={datas?.voucher}
                              style={{
                                height: "400px",
                                width: "400px",
                                maxHeight: "400px",
                                maxWidth: "400px",
                                backgroundRepeat: "no-repeat",
                              }}
                              alt="Factura"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              )}

              {/*  <Col xs="auto">
                <Table
                  striped
                  size="sm"
                  borderless
                  className="fs--1 text-right"
                >
                  <tbody>
                    <tr className="border-top">
                      <th className="text-900" colSpan={3}>
                        Total:
                      </th>
                      <td className="font-weight-semi-bold text-right">
                        <NumberFormat
                          className="text-right"
                          displayType="text"
                          allowedDecimalSeparators={true}
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale
                          prefix={`${baseCurrency.symbol} `}
                          value={datas?.total_amount}
                        />
                        <NumberFormat
                          displayType="text"
                          prefix={" | " + activeRate?.currency?.iso + " "}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={datas?.total_amount * (activeRate?.value || 1)}
                        />
                      </td>
                    </tr>
             
                  </tbody>
                </Table>
              </Col> */}
            </Row>
            {dataConfig.loading ? (
              <Spinner />
            ) : (
              <div className="text-start text-muted mt-3 pt-1 mb-0">
                <Logo
                  to={null}
                  styleImage={{
                    width: "100px",
                  }}
                  className={"mb-2"}
                />
                <div className="mb-0">
                  {dataConfig?.data?.note !== "" && (
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      className="mr-2"
                      size="sm"
                    />
                  )}
                  <pre
                    style={{
                      fontFamily: "Open Sans",
                      fontSize: ".83333rem",
                      color: "#5e6e82",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    {dataConfig?.data?.note}
                  </pre>
                </div>
              </div>
            )}
            <Modal isOpen={collapseOne} data-testid="modal">
              <ModalHeader>Confirmación</ModalHeader>
              <ModalBody>
                <p className="mb-0 font-weight-bold fs--1">
                  ¿Está seguro de cancelar el pago? Podrá realizar nuevamente el
                  pago.
                </p>
              </ModalBody>
              <ModalFooter>
                <Button onClick={() => collapseOneOpen(!collapseOne)}>
                  Cancelar
                </Button>
                <Button
                  data-testid="submit-button"
                  color="primary"
                  type="submit"
                  onClick={cancel}
                >
                  Sí, cancelar
                </Button>
              </ModalFooter>
            </Modal>
          </CardBody>
        ) : (
          <Loader padding="py-5" />
        )}
      </Card>
    </Fragment>
  );
};

export default withRedirect(PropertyPaymentDetail);
